import { Link } from "react-router-dom"

import { Section, Text } from "@jewlr/storybook/info"
import StampedReviewsWidget from "components/stamped-reviews-widget"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"

import ReviewsChart from "./reviews-chart"

const socialLinks = [
  {
    followers: "1.5M+",
    height: "310",
    image: "icons/facebook.png",
    name: "Facebook",
    url: "https://www.facebook.com/jewlrcom",
    width: "309",
  },
  {
    followers: "180K+",
    height: "487",
    image: "info/reviews/instagram.png",
    name: "Instagram",
    url: "https://www.instagram.com/jewlr",
    width: "487",
  },
  {
    followers: "26K+",
    height: "487",
    image: "info/reviews/pinterest.png",
    name: "Pinterest",
    url: "https://www.pinterest.ca/jewlrcom",
    width: "487",
  },
]

const Reviews = () => {
  return (
    <div className="px-16">
      <div className="contained text-left">
        <Text className="mb-32">
          {jewlr_t("terms.Jewelry")} and customer experience is our passion, and
          our customers love us for it. Read what some of our customers have to
          say about us.
        </Text>
        <ReviewsChart />
      </div>
      <StampedReviewsWidget />
      <div className="contained my-56">
        <Section hasBg>
          <h2 className="body mb-8 text-center">More Reviews On</h2>
          <div className="tablet:flex-row flex flex-col items-center">
            <div className="tablet:border-r tablet:border-b-0 border-grey-20 flex-1 border-b py-16 text-center">
              <a
                href="https://www.shopperapproved.com/reviews/jewlr.com/"
                rel="noreferrer"
                target="_blank"
              >
                <Image
                  alt="Shopper Approved"
                  className="w-(--base-width) desktop:w-(--desktop-width)"
                  height="718"
                  src={require("images/info/reviews/shoppers-approved.png")}
                  style={{
                    "--base-width": "140px",
                    "--desktop-width": "198px",
                  }}
                  width="2430"
                />
              </a>
            </div>
            <div className="flex-1 py-16 text-center">
              <a
                href="https://www.trustpilot.com/review/jewlr.com"
                rel="noreferrer"
                target="_blank"
              >
                <Image
                  alt="Trustpilot"
                  className="w-(--base-width) tablet:w-(--tablet-width)"
                  height="278"
                  src={require("images/info/reviews/Trustpilot.svg")}
                  style={{
                    "--base-width": "177px",
                    "--tablet-width": "268px",
                  }}
                  width="1133"
                />
              </a>
            </div>
          </div>
        </Section>
      </div>
      <div className="contained">
        <h2 className="body mb-8 text-center">Stay Connected</h2>
        <div
          className="grid grid-cols-3"
          style={{
            "--base-width": "34px",
            "--desktop-width": "66px",
            "--tablet-width": "46px",
          }}
        >
          {socialLinks.map((social) => (
            <div
              className="tablet:gap-16 flex items-center gap-6 py-16"
              key={social.name}
            >
              <div className="flex-1 text-right">
                <a href={social.url} rel="noopener noreferrer" target="_blank">
                  <Image
                    alt={social.name}
                    className="w-(--base-width) desktop:w-(--desktop-width) tablet:w-(--tablet-width)"
                    height={social.height}
                    src={require(`images/${social.image}`)}
                    width={social.width}
                  />
                </a>
              </div>
              <div className="flex-1">
                <p className="text-14 tablet:text-22 tablet:pt-0 pt-4">
                  {social.followers}
                </p>
                <p className="text-neutral text-12 table:text-20">Followers</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Divider className="mx-auto my-48" />
      <div className="contained mb-48 text-center">
        <Button
          asChild
          className="tablet:py-16 px-26 tablet:px-32 border border-black py-10"
          variant="tertiary"
        >
          <Link
            data-lc="reviews"
            to={`/${jewlr_t("terms.personalized")}-${jewlr_t("terms.jewelry")}`}
          >
            START {jewlr_t("terms.Personalizing").toUpperCase()}
          </Link>
        </Button>
      </div>
    </div>
  )
}

export default Reviews
